import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { styled } from '@mui/material';

export const Component = styled(SvgIcon)<SvgIconProps>(({ theme }) => ({
    '&.MuiSvgIcon-fontSizeSmall': {
        fontSize: '20px',
    },
    '&.MuiSvgIcon-fontSizeMedium': {
        fontSize: '24px',
    },
    '&.MuiSvgIcon-fontSizeLarge': {
        fontSize: '35px',
    },
}));
